import { render } from "./App.vue?vue&type=template&id=76120864"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=76120864&lang=less"

import exportComponent from "/var/jenkins_home/workspace/yyzd/ryom-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__